import rules from "../../utils/wordSpiderRules";
export const LETTER_POINTS: Record<string, number> = rules.LETTER_POINTS;

export function getLetterPoints(letter: string): number | undefined {
  if (!letter) {
    return undefined;
  }
  return LETTER_POINTS[letter.toUpperCase()];
}
